// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__+5gRQ"};